

// import { useState } from 'react';

// /**
//  * Custom hook for form validation
//  * Validates form sections based on question requirements and conditional logic
//  */
// export const useFormValidation = () => {
//     const [errors, setErrors] = useState({});

//     /**
//      * Validates a section of the form
//      * @param {Object} section - The section object containing questions
//      * @param {Object} data - The form data object
//      * @returns {boolean} - True if validation passes, false otherwise
//      */
//     const validateSection = (section, data) => {
//         const newErrors = {};
//         let isValid = true;

//         /**
//          * Recursively validates questions
//          * @param {Array} questions - Array of question objects
//          */
//         const validateQuestions = (questions) => {
//             if (!questions || !Array.isArray(questions)) return;

//             questions.forEach(question => {
//                 // Skip section headers (non-input elements)
//                 if (question.type === 'section') {
//                     return;
//                 }

//                 // Skip group containers (validate their nested questions instead)
//                 if (question.type === 'group' && question.questions) {
//                     validateQuestions(question.questions);
//                     return;
//                 }

//                 // Check if field should be visible based on conditionalLogic
//                 if (question.conditionalLogic) {
//                     const { condition, value } = question.conditionalLogic;
//                     const conditionValue = data[condition];

//                     // If condition is not met, skip validation for this field
//                     if (conditionValue !== value) {
//                         return;
//                     }
//                 }

//                 // Check if field is hidden and should be skipped
//                 if (question.hidden) {
//                     // Hidden fields are only validated if they have a value (were shown at some point)
//                     if (!data[question.id]) {
//                         return;
//                     }
//                 }

//                 // Validate required fields
//                 if (question.required) {
//                     const fieldValue = data[question.id];

//                     // Check for empty values
//                     if (
//                         fieldValue === undefined ||
//                         fieldValue === null ||
//                         fieldValue === '' ||
//                         (Array.isArray(fieldValue) && fieldValue.length === 0)
//                     ) {
//                         newErrors[question.id] = `${question.text || question.id} is required`;
//                         isValid = false;
//                     }
//                 }

//                 // Validate number fields
//                 if (question.type === 'number' && question.validation) {
//                     const value = data[question.id];

//                     // Only validate if field has a value
//                     if (value !== undefined && value !== null && value !== '') {
//                         const numValue = Number(value);

//                         if (isNaN(numValue)) {
//                             newErrors[question.id] = 'Please enter a valid number';
//                             isValid = false;
//                         } else {
//                             // Check minimum value
//                             if (question.validation.min !== undefined && numValue < question.validation.min) {
//                                 newErrors[question.id] = `Minimum value is ${question.validation.min}`;
//                                 isValid = false;
//                             }

//                             // Check maximum value
//                             if (question.validation.max !== undefined && numValue > question.validation.max) {
//                                 newErrors[question.id] = `Maximum value is ${question.validation.max}`;
//                                 isValid = false;
//                             }
//                         }
//                     }
//                 }

//                 // Validate email fields
//                 if (question.type === 'email' || question.validation?.type === 'email') {
//                     const value = data[question.id];

//                     if (value && value !== '') {
//                         const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//                         if (!emailRegex.test(value)) {
//                             newErrors[question.id] = 'Please enter a valid email address';
//                             isValid = false;
//                         }
//                     }
//                 }

//                 // Validate text length constraints
//                 if ((question.type === 'text' || question.type === 'textarea') && question.validation) {
//                     const value = data[question.id];

//                     if (value && value !== '') {
//                         // Check minimum length
//                         if (question.validation.minLength && value.length < question.validation.minLength) {
//                             newErrors[question.id] = `Minimum length is ${question.validation.minLength} characters`;
//                             isValid = false;
//                         }

//                         // Check maximum length
//                         if (question.validation.maxLength && value.length > question.validation.maxLength) {
//                             newErrors[question.id] = `Maximum length is ${question.validation.maxLength} characters`;
//                             isValid = false;
//                         }
//                     }
//                 }

//                 // Validate pattern (regex)
//                 if (question.validation?.pattern) {
//                     const value = data[question.id];

//                     if (value && value !== '') {
//                         const regex = new RegExp(question.validation.pattern);
//                         if (!regex.test(value)) {
//                             newErrors[question.id] = question.validation.patternMessage || 'Invalid format';
//                             isValid = false;
//                         }
//                     }
//                 }

//                 // Validate custom validation rules
//                 if (question.validation?.custom && typeof question.validation.custom === 'function') {
//                     const customError = question.validation.custom(data[question.id], data);
//                     if (customError) {
//                         newErrors[question.id] = customError;
//                         isValid = false;
//                     }
//                 }

//                 // Validate condition_with_duration fields
//                 if (question.type === 'condition_with_duration') {
//                     const value = data[question.id];

//                     if (question.required && value) {
//                         // Check if status is selected
//                         if (!value.status) {
//                             newErrors[question.id] = 'Please select a status';
//                             isValid = false;
//                         }

//                         // If status is YES, check if duration is provided
//                         if (value.status === 'YES') {
//                             if (!value.duration || !value.duration.years) {
//                                 newErrors[question.id] = 'Please provide duration information';
//                                 isValid = false;
//                             }
//                         }
//                     }
//                 }

//                 // Validate signature fields
//                 if (question.type === 'signature' && question.required) {
//                     const value = data[question.id];

//                     if (!value || value === '') {
//                         newErrors[question.id] = 'Signature is required';
//                         isValid = false;
//                     }
//                 }

//                 // Validate table/conditional fields
//                 if (question.type === 'conditional' && question.required) {
//                     const value = data[question.id];

//                     // Check if conditionalLogic allows this field to be shown
//                     if (question.conditionalLogic) {
//                         const { condition, value: conditionValue } = question.conditionalLogic;

//                         if (data[condition] === conditionValue) {
//                             // Field should be shown, validate it
//                             if (!value || (Array.isArray(value) && value.length === 0)) {
//                                 newErrors[question.id] = 'At least one entry is required';
//                                 isValid = false;
//                             }
//                         }
//                     }
//                 }

//                 // Recursively validate nested questions in groups
//                 if (question.questions && Array.isArray(question.questions)) {
//                     validateQuestions(question.questions);
//                 }
//             });
//         };

//         // Start validation
//         validateQuestions(section.questions);

//         // Update errors state
//         setErrors(newErrors);

//         // Log validation results in development
//         if (process.env.NODE_ENV === 'development') {
//             if (!isValid) {
//                 console.log('Validation failed for section:', section.id);
//                 console.log('Errors:', newErrors);
//             } else {
//                 console.log('Validation passed for section:', section.id);
//             }
//         }

//         return isValid;
//     };

//     /**
//      * Clears all errors
//      */
//     const clearErrors = () => {
//         setErrors({});
//     };

//     /**
//      * Clears error for a specific field
//      * @param {string} fieldId - The field ID to clear error for
//      */
//     const clearFieldError = (fieldId) => {
//         setErrors(prev => {
//             const newErrors = { ...prev };
//             delete newErrors[fieldId];
//             return newErrors;
//         });
//     };

//     /**
//      * Sets a custom error for a field
//      * @param {string} fieldId - The field ID
//      * @param {string} errorMessage - The error message
//      */
//     const setFieldError = (fieldId, errorMessage) => {
//         setErrors(prev => ({
//             ...prev,
//             [fieldId]: errorMessage
//         }));
//     };

//     return {
//         errors,
//         validateSection,
//         clearErrors,
//         clearFieldError,
//         setFieldError
//     };
// };

import { useState, useCallback } from 'react';

export const useFormValidation = () => {
    const [errors, setErrors] = useState({});

    // Validate a single field
    const validateField = useCallback((question, value, allData = {}) => {
        const errors = [];

        // Check if required
        if (question.required) {
            if (value === undefined || value === null || value === '' ||
                (Array.isArray(value) && value.length === 0)) {
                errors.push('This field is required');
            }
        }

        // Validate number type
        if (question.type === 'number' && value !== undefined && value !== '') {
            const numValue = parseFloat(value);

            if (isNaN(numValue)) {
                errors.push('Please enter a valid number');
            } else {
                // Check min value
                if (question.validation?.min !== undefined && numValue < question.validation.min) {
                    errors.push(`Minimum value is ${question.validation.min}`);
                }

                // Check max value
                if (question.validation?.max !== undefined && numValue > question.validation.max) {
                    errors.push(`Maximum value is ${question.validation.max}`);
                }
            }
        }

        // Validate date type
        if (question.type === 'date' && value) {
            const dateValue = new Date(value);
            if (isNaN(dateValue.getTime())) {
                errors.push('Please enter a valid date');
            }
        }

        // Validate email format (if you have email type)
        if (question.type === 'email' && value) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(value)) {
                errors.push('Please enter a valid email address');
            }
        }

        // Validate inclusion criteria
        if (question.validation?.mustBeTrue && value !== 'YES') {
            errors.push('This must be YES for subject to be eligible');
        }

        // Validate exclusion criteria
        if (question.validation?.mustBeFalse && value === 'YES') {
            errors.push('This must be NO for subject to be eligible');
        }

        // Informed Consent validation

        if (
            question.id === "consent_obtained" &&
            question.required &&
            !value
        ) {
            errors.push(
                "Was informed consent obtained?"
            );
        }

        // If YES -> date required
        if (
            allData.consent_obtained === "YES" &&
            question.id === "consent_date"
        ) {

            if (!value) {
                errors.push(
                    "Consent date is required"
                );
            } else {

                const selectedDate =
                    new Date(value);

                const today =
                    new Date();

                today.setHours(
                    0,0,0,0
                );

                if(selectedDate > today){
                    errors.push(
                    "Future date not allowed"
                    );
                }
            }
        }

        // If NO -> reason required
        if (
            allData.consent_obtained==="NO" &&
            question.id===
            "consent_not_obtained_reason"
        ) {

            if(
                !value ||
                !value.trim()
            ){
                errors.push(
                    "Please provide reason"
                );
            }
        }

        // Custom validation based on formula or calculated fields
        if (question.type === 'calculated' && question.formula) {
            // Calculated fields are usually read-only, so no validation needed
        }


        return errors.length > 0 ? errors[0] : null;
    }, []);

    // Validate entire section
    const validateSection = useCallback((section, data, conditionalVisibility = {}) => {
        const newErrors = {};
        let isValid = true;

        const validateQuestions = (questions, parentVisible = true) => {
            if (!questions) return;

            questions.forEach(question => {
                // Check visibility based on conditional logic
                let isVisible = parentVisible;

                if (question.conditionalLogic) {
                    const { condition, value } = question.conditionalLogic;
                    const conditionValue = data[condition];
                    isVisible = conditionValue === value;
                }

                // Check conditional visibility state
                if (question.id && conditionalVisibility[question.id] !== undefined) {
                    isVisible = conditionalVisibility[question.id];
                }

                if (!isVisible) return;

                // Validate the field
                const error = validateField(question, data[question.id], data);
                if (error) {
                    newErrors[question.id] = error;
                    isValid = false;
                }

                // Recursively validate nested questions
                if (question.questions) {
                    if (Array.isArray(question.questions)) {
                        validateQuestions(question.questions, isVisible);
                    } else if (question.type === 'conditional') {
                        // For conditional inputs, check if parent condition is met
                        const shouldShow = question.conditionalLogic &&
                            data[question.conditionalLogic.condition] === question.conditionalLogic.value;
                        validateQuestions(question.questions, shouldShow && isVisible);
                    }
                }
            });
        };

        if (section.questions) {
            validateQuestions(section.questions);
        }

        setErrors(newErrors);
        return isValid;
    }, [validateField]);

    // Clear specific field error
    const clearFieldError = useCallback((fieldId) => {
        setErrors(prev => {
            const newErrors = { ...prev };
            delete newErrors[fieldId];
            return newErrors;
        });
    }, []);

    // Clear all errors
    const clearAllErrors = useCallback(() => {
        setErrors({});
    }, []);

    // Set error for specific field
    const setFieldError = useCallback((fieldId, errorMessage) => {
        setErrors(prev => ({
            ...prev,
            [fieldId]: errorMessage
        }));
    }, []);

    return {
        errors,
        setErrors,
        validateField,
        validateSection,
        clearFieldError,
        clearAllErrors,
        setFieldError
    };
};